import PropTypes from 'prop-types'
import classNames from 'classnames'
import Link from 'next/link'

import Typography from '../typography'
import Icon from '../icon'
import { useBreakpoint } from '../../../hooks/breakpoint'

import BrandIsotype from '../icon/banuu-isotipo.svg'
import ChevronRight from '../icon/chevron-right.svg'

const Breadcrumb = ({ items, ...attrs }) => {
  const breakpoint = useBreakpoint()

  attrs.className = classNames(
    attrs.className,
    [
      'pb-4',
      'border-b',
      'border-green-300',
      'flex',
      'items-start',
      'sm:items-center'
    ]
  )

  return (
    <div {...attrs}>
      <Link href={'/'}>
        <a className="flex-none">
          <Icon
            width={breakpoint.mdAndUp ? 40 : 24}
            height={breakpoint.mdAndUp ? 56 : 33}
            svg={BrandIsotype}
            className={'text-green-500'} />
        </a>
      </Link>
      <ul
        className={
          classNames([
            'flex',
            'flex-col',
            'sm:flex-row',
            'ml-2'
          ])
        }
        style={{
          width: '90%'
        }}
      >
        {
          items.map((item, index) => {
            return (
              <li
                className="flex sm:items-start text-green-500"
                key={index}>
                <Icon
                  width={24}
                  height={24}
                  svg={ChevronRight}
                  className={'text-red-500 flex-none'} />
                {
                  item.href
                    ? <Link href={item.href}>
                      <a target={item.target} className="flex">
                        <Typography
                          tag={'div'}
                          size={'three'}
                          type={'medium'}>
                          {item.text}
                        </Typography>
                      </a>
                    </Link>
                    : <Typography
                      tag={'div'}
                      size={'three'}
                      type={'medium'}>
                      {item.text}
                    </Typography>
                }
              </li>
            )
          })
        }
      </ul>
    </div>
  )
}

Breadcrumb.propTypes = {
  items: PropTypes.oneOfType([PropTypes.array, PropTypes.string, PropTypes.node])
}

export default Breadcrumb
